import { createFileRoute } from '@tanstack/react-router';

import { AdminAuthorsPage } from '@/components/admin/authors-page';
import { adminHead } from '@/lib/seo';
import { adminListAuthorsFn } from '@/server/functions/admin';

export const Route = createFileRoute('/_admin/admin/authors')({
    component: AuthorsRoute,
    head: () => adminHead('כותבים', '/admin/authors'),
    staleTime: 0,
    preloadStaleTime: 0,
    loader: () => adminListAuthorsFn({ data: { limit: 50 } }),
});

function AuthorsRoute() {
    const data = Route.useLoaderData();
    return <AdminAuthorsPage initial={data} />;
}
